import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { SelectionAdapter } from 'components/SelectPropertiesDrawerV2';
import { FilterFormikData } from 'components/RecordsListView/types';

/**
 * Wires SelectPropertiesDrawerV2 to the records list filter's Formik form:
 * the drawer's confirmed selection lands in the same four fields the filter
 * reads (count, total area, clear).
 *
 * Must be called inside a Formik context.
 */
const useRecordsFilterSelectionAdapter = (): SelectionAdapter => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext<
    FilterFormikData
  >();

  return useMemo(
    () => ({
      initialCropZones: values.cropZoneIds ?? [],
      existingCropZones: values.cropZones ?? [],
      onConfirm: ({ cropZoneIds, totalArea, cropZones, sourceType }) => {
        setFieldValue('cropZoneIds', cropZoneIds);
        setFieldValue('totalArea', totalArea);
        setFieldValue('cropZones', cropZones);
        setFieldValue('sourceType', sourceType);
        setFieldTouched('cropZoneIds', true);
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [values.cropZoneIds, values.cropZones]
  );
};

export default useRecordsFilterSelectionAdapter;
